import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

// MODEL
import {
  IndividualCheckInCheckOutResponse,
  CheckInCheckOutCenterState,
  CheckInCheckOutStep,
  VerificationType,
  ActivityAttendance,
  VolunteerType,
  Organization,
  VolunteerData
} from 'model';

export const changeCheckInCheckOutCenterLoading: CaseReducer<CheckInCheckOutCenterState, PayloadAction<boolean>> = (
  state,
  action
) => {
  state.loading = action.payload;
};

export const changeCheckInCheckOutCenterVolunteerType: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<undefined | VolunteerType>
> = (state, action) => {
  state.selectedVolunteerType = action.payload;
};

export const changeCheckInCheckOutCenterVolunteerData: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<undefined | VolunteerData>
> = (state, action) => {
  state.volunteerData = action.payload;
};

export const changeCheckInCheckOutCenterCenterName: CaseReducer<CheckInCheckOutCenterState, PayloadAction<string>> = (
  state,
  action
) => {
  state.centerName = action.payload;
};

export const changeCheckInCheckOutCenterEventList: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<ActivityAttendance[]>
> = (state, action) => {
  state.eventList = action.payload;
};

export const changeCheckInCheckOutCenterOrganizations: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<Organization[]>
> = (state, action) => {
  state.organizations = action.payload;
};

export const changeCheckInCheckOutCenterSelectedEvent: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<undefined | ActivityAttendance>
> = (state, action) => {
  state.selectedEvent = action.payload;
};

export const changeCheckInCheckOutCenterVerificationType: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<undefined | VerificationType>
> = (state, action) => {
  state.verificationType = action.payload;
};

export const changeCheckInCheckOutCenterPhoneNumber: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<string | undefined>
> = (state, action) => {
  state.phone = action.payload;
};

export const changeCheckInCheckOutCenterCountryCode: CaseReducer<CheckInCheckOutCenterState, PayloadAction<string>> = (
  state,
  action
) => {
  state.countryCode = action.payload;
};

export const changeCheckInCheckOutCenterNRIC: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<string | undefined>
> = (state, action) => {
  state.nric = action.payload;
};

export const changeCheckInCheckOutCenterShowSomethingWentWrong: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<boolean>
> = (state, action) => {
  state.showSomethingWentWrong = action.payload;
};

export const setCheckInCheckOutStep: CaseReducer<CheckInCheckOutCenterState, PayloadAction<CheckInCheckOutStep>> = (
  state,
  action
) => {
  state.step = action.payload;
};

export const setAttendanceStatusTime: CaseReducer<CheckInCheckOutCenterState, PayloadAction<number | undefined>> = (
  state,
  action
) => {
  state.attendanceStatusTime = action.payload;
};

export const setIndividualCheckInCheckOutData: CaseReducer<
  CheckInCheckOutCenterState,
  PayloadAction<IndividualCheckInCheckOutResponse | undefined>
> = (state, action) => {
  state.individualCheckInCheckOut = action.payload;
};
